import { useState } from "react";
import { FaTimes } from "react-icons/fa";
import { useBandeauAnnonce } from "../hooks/useBandeauAnnonce";

/**
 * Bandeau affichant l'annonce publiée depuis le back-office, en haut du site.
 *
 * Ne rend rien tant qu'aucune annonce n'est publiée, ni pendant le prérendu
 * react-snap, ni en cas d'indisponibilité de l'API : dans tous ces cas le
 * résultat attendu est identique, le bandeau n'apparaît pas — sans message
 * d'erreur, sans loader et sans toast.
 */
const AnnouncementBar = () => {
    const isReactSnap = typeof navigator !== "undefined" && navigator.userAgent === "ReactSnap";
    const annonce = useBandeauAnnonce();

    // Fermeture volontairement en state local : ce composant est monté dans
    // App.js au-dessus de <Routes>, react-router ne remplace que le sous-arbre
    // des routes et ne le démonte donc jamais lors d'une navigation SPA. L'état
    // survit à tous les changements de page, et le bandeau ne réapparaît qu'au
    // rechargement complet. Aucun stockage navigateur n'est nécessaire.
    const [isDismissed, setIsDismissed] = useState(false);

    if (isReactSnap || !annonce || isDismissed) {
        return null;
    }

    return (
        <div
            role="region"
            aria-label="Annonce PretUp"
            className="mx-auto flex max-w-7xl items-center gap-3 bg-secondary px-4 py-1.5 text-white"
        >
            {/* Texte simple, jamais dangerouslySetInnerHTML : le champ du back-office
                est un <input type="text"> renvoyé brut par l'API, le rendu texte de
                React est la seule protection côté site public. */}
            <p className="line-clamp-2 flex-1 text-center text-sm leading-snug">{annonce.phrase}</p>

            <button
                type="button"
                onClick={() => setIsDismissed(true)}
                aria-label="Fermer l'annonce"
                className="flex-shrink-0 rounded p-0.5 transition hover:bg-white/20"
            >
                <FaTimes size={14} />
            </button>
        </div>
    );
};

export default AnnouncementBar;
